import {message} from 'ant-design-vue';
let __router;
export const setRouter = (router,route)=>{
  __router = {
    router: router,
    route: route
  };
}
export const getRouter = ()=>{
  return __router;
}
export const iscode = (res, isShowSussessMessage,isTrueShow=true)=>{

  if(!res)return
  if(res.code === 0){
    isShowSussessMessage &&isTrueShow&& message.success(res.msg|| res.message);
    return true;
  } else {
    isShowSussessMessage && message.error(res.msg|| res.message||'服务器错误');
    return false;
  }
}